import {IHttpService} from "angular";
import {IdempotencyRequest, StripeCardsRequest, StripeCardSummary} from "../types/TfStripeTypes";
import {NewStripeCard, NgStripe} from "../types/StripeTypes";
import {CardCreateResult, StripeCardCreateResult} from "../models/StripeCardCreateResult";

export class StripeService {

    public static id = "stripeService";

    /** @ngInject */
    public constructor(private $http: IHttpService, private stripe: NgStripe) {

    }

    public async cards(): Promise<Array<StripeCardSummary>> {
        const response = await this.$http.get<StripeCardsRequest>("/tradefloor/api/stripe/cards");
        return response.data!.cards;
    }

    public async idempotency(): Promise<string> {
        const response = await this.$http.get<IdempotencyRequest>("/tradefloor/api/stripe/idempotent");
        return response.data!.key;
    }

    public async createCard(idempotency: string, card: NewStripeCard): Promise<CardCreateResult> {
        const token = await this.createCardToken(card);
        return this.linkCard(idempotency, token);
    }

    public async createCardToken(card: NewStripeCard): Promise<string> {
        const response = await this.stripe.card.createToken(card);
        return response.id;
    }

    public async linkCard(idempotency: string, cardToken: string): Promise<CardCreateResult> {
        const url = `/tradefloor/api/stripe/cards?ik=${idempotency}`;
        try {
            const response = await this.$http.put<StripeCardSummary>(url, cardToken);
            const card = response.data!;
            return StripeCardCreateResult.success(card);
        } catch (e) {
            const reason = "There was an error processing your card. Please try again later.";
            return StripeCardCreateResult.failure(reason);
        }
    }
}
